import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { groupBy, isEmpty } from "lodash";
import pluralize from "pluralize";

import { Title } from "./CancelCOIssueSummary";

const NO_PAYMENTS_MESSAGE =
  "Cancelling Purchase Order will remove all Change Orders and revert Purchase Order to first Pre-Issue state. These changes are not reversible. Are you sure?";

const CO_PAYMENTS_TITLE =
  "Change Order Issue cannot be cancelled as there are payments against shipments added in the CO. The following payments need to be cancelled prior to cancelling CO Issue.";

const PO_PAYMENTS_TITLE =
  "Purchase Order Issue cannot be cancelled as it has paid invoices linked to it. The following payments need to be cancelled prior to cancelling PO Issue.";

const PRICE_CHANGE_TITLE =
  "Change Order Issue cannot be cancelled because it changed the unit price of specs that already have invoice quantities received. The following invoices need to be cancelled prior to cancelling CO Issue.";

const InvoiceTables = ({ rows }) => {
  const invoices = groupBy(rows, "invoiceNumber");

  return (
    <Fragment>
      <h3>
        <span style={{ paddingRight: "24px" }}>
          {Object.keys(invoices).length}{" "}
          {pluralize("Payment", Object.keys(invoices).length)}
        </span>
      </h3>
      {Object.keys(invoices).map(invoiceNumber => (
        <Fragment key={invoiceNumber}>
          <h4 style={{ marginTop: "15px" }}>
            <span style={{ paddingRight: "24px" }}>
              Invoice #{invoiceNumber}
            </span>
          </h4>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <td style={{ paddingRight: "24px", width: "80%" }}>
                  <b>Spec</b>
                </td>
                <td>
                  <b>Qty.</b>
                </td>
              </tr>
            </thead>
            <tbody>
              {invoices[invoiceNumber].map(
                ({ invoiceNumber, customNumber, quantity }, i) => (
                  <tr key={`${invoiceNumber}-${i}`}>
                    <td>{customNumber}</td>
                    <td>{quantity}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </Fragment>
      ))}
    </Fragment>
  );
};
InvoiceTables.propTypes = {
  rows: PropTypes.array,
};

const BlockerSection = ({ title, rows }) =>
  isEmpty(rows) ? null : (
    <Fragment>
      <Title>{title}</Title>
      <InvoiceTables rows={rows} />
    </Fragment>
  );
BlockerSection.propTypes = {
  title: PropTypes.string,
  rows: PropTypes.array,
};

export const InvoicePayments = ({
  invoicePayments = {},
  changeOrder = false,
}) => {
  const {
    specPayments,
    specPaymentsInChangeOrder,
    specPriceChangesInChangeOrder,
  } = invoicePayments;

  const paymentRows = changeOrder ? specPaymentsInChangeOrder : specPayments;
  const priceRows = changeOrder ? specPriceChangesInChangeOrder : [];

  if (isEmpty(paymentRows) && isEmpty(priceRows)) {
    return <Title>{NO_PAYMENTS_MESSAGE}</Title>;
  }

  return (
    <Fragment>
      <BlockerSection
        title={changeOrder ? CO_PAYMENTS_TITLE : PO_PAYMENTS_TITLE}
        rows={paymentRows}
      />
      <BlockerSection title={PRICE_CHANGE_TITLE} rows={priceRows} />
    </Fragment>
  );
};
InvoicePayments.propTypes = {
  invoicePayments: PropTypes.object,
  changeOrder: PropTypes.bool,
};
